module.exports = __webpack_public_path__ + "static/media/Soybean4V4-V5.71af5046.PNG";